export interface Tip {
    id: string
    title: string
    content: string
    category: 'study' | 'test-taking' | 'motivation' | 'strategy' | 'wellness'
    icon?: string
}

export const tips: Tip[] = [
    {
        id: 'tip-1',
        title: 'Start with Easy Questions',
        content: 'Begin each section with questions you find easiest. This builds confidence and ensures you secure those points before tackling harder problems.',
        category: 'test-taking',
        icon: '🎯'
    },
    {
        id: 'tip-2',
        title: 'Read Questions Carefully',
        content: 'Take time to understand what each question is really asking. Many mistakes come from misreading, not from lack of knowledge.',
        category: 'test-taking',
        icon: '📖'
    },
    {
        id: 'tip-3',
        title: 'Practice Daily',
        content: 'Consistency is key! Even 20-30 minutes of focused practice each day is more effective than cramming for hours once a week.',
        category: 'study',
        icon: '📅'
    },
    {
        id: 'tip-4',
        title: 'Review Your Mistakes',
        content: 'Don\'t just move on after getting a question wrong. Understand why you made the mistake and how to avoid it next time.',
        category: 'study',
        icon: '🔍'
    },
    {
        id: 'tip-5',
        title: 'Time Management Matters',
        content: 'Practice with a timer to build your pacing skills. Know how much time you can spend on each question type.',
        category: 'strategy',
        icon: '⏱️'
    },
    {
        id: 'tip-6',
        title: 'Eliminate Wrong Answers',
        content: 'When stuck, eliminate obviously wrong choices first. This increases your chances even if you have to guess.',
        category: 'strategy',
        icon: '✂️'
    },
    {
        id: 'tip-7',
        title: 'Take Breaks',
        content: 'Your brain needs rest to consolidate learning. Take short breaks during study sessions to maintain focus and retention.',
        category: 'wellness',
        icon: '🧘'
    },
    {
        id: 'tip-8',
        title: 'Sleep Well Before Tests',
        content: 'A well-rested brain performs significantly better. Aim for 7-9 hours of sleep, especially the night before practice tests.',
        category: 'wellness',
        icon: '😴'
    },
    {
        id: 'tip-9',
        title: 'Focus on Your Weaknesses',
        content: 'Identify your weak areas and dedicate extra time to them. Improvement in weak areas yields the biggest score gains.',
        category: 'study',
        icon: '💪'
    },
    {
        id: 'tip-10',
        title: 'Stay Positive',
        content: 'Your mindset matters! Believe in your ability to improve. Every practice session is a step toward your goal.',
        category: 'motivation',
        icon: '✨'
    },
    {
        id: 'tip-11',
        title: 'Use Process of Elimination',
        content: 'Cross out answers you know are wrong. This narrows your choices and improves your odds of selecting the correct answer.',
        category: 'test-taking',
        icon: '🎲'
    },
    {
        id: 'tip-12',
        title: 'Master the Basics First',
        content: 'Build a strong foundation before tackling advanced topics. Mastery of fundamentals makes complex problems easier.',
        category: 'study',
        icon: '🏗️'
    },
    {
        id: 'tip-13',
        title: 'Track Your Progress',
        content: 'Keep a log of your practice scores and improvement areas. Seeing your progress is motivating and helps identify patterns.',
        category: 'strategy',
        icon: '📊'
    },
    {
        id: 'tip-14',
        title: 'Stay Hydrated',
        content: 'Drink water throughout your study sessions. Proper hydration improves concentration and cognitive performance.',
        category: 'wellness',
        icon: '💧'
    },
    {
        id: 'tip-15',
        title: 'Celebrate Small Wins',
        content: 'Acknowledge your progress, no matter how small. Each mastered skill and improved score is worth celebrating!',
        category: 'motivation',
        icon: '🎉'
    }
]

export function getTipOfTheDay(): Tip {
    const today = new Date()
    const dayOfYear = Math.floor((today.getTime() - new Date(today.getFullYear(), 0, 0).getTime()) / 86400000)
    const tipIndex = dayOfYear % tips.length
    return tips[tipIndex]
}
